import { render, staticRenderFns } from "./OrderReferenceIndex.vue?vue&type=template&id=6925b96f&"
import script from "./OrderReferenceIndex.vue?vue&type=script&lang=js&"
export * from "./OrderReferenceIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrderReferenceIndex.vue?vue&type=style&index=0&id=6925b96f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports